import { render, staticRenderFns } from "./BatchMbrAssetSubsDlg.vue?vue&type=template&id=8b15cd32"
import script from "./BatchMbrAssetSubsDlg.vue?vue&type=script&lang=js"
export * from "./BatchMbrAssetSubsDlg.vue?vue&type=script&lang=js"
import style0 from "./BatchMbrAssetSubsDlg.vue?vue&type=style&index=0&id=8b15cd32&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports